// @ts-nocheck
// Estudo 2.0 — Feed (app bar, marco ativo, Fios, filtros, lista). Apresentação pura.
import React from 'react';
import { IcoFlame, IcoCheck, IcoClock, IcoChevDown, IcoTheme, IcoSearch, IcoClose, IcoBack } from './icons2';
import { BookCover, STUDY_FILTERS } from './ui2';
import { PostCard } from './cards2';

function MilestoneRail({ milestones, selected, onSelect }: any) {
  if (!milestones?.length) return null;
  return (
    <div className="scroll-x" style={{ display: 'flex', gap: 8, padding: '0 16px 2px' }}>
      {milestones.map((m: any) => {
        const on = selected === m.id;
        const closed = m.state === 'closed';
        return (
          <button key={m.id} onClick={() => onSelect(on ? null : m.id)} style={{
            flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2,
            padding: '9px 14px', borderRadius: 12, minWidth: 120, textAlign: 'left',
            background: on ? 'var(--paper-3)' : 'var(--paper-2)', border: `1px solid ${on ? 'var(--ember)' : 'var(--line)'}`,
          }}>
            <span className="mono" style={{ fontSize: 9.5, color: closed ? 'var(--sage)' : 'var(--ember)', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', gap: 4 }}>
              {closed ? <IcoCheck size={11} /> : <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--ember)', animation: 'e2Pulse 2s infinite' }} />}
              Marco {m.n}
            </span>
            <span style={{ fontSize: 12.5, fontWeight: 600, color: on ? 'var(--ink)' : 'var(--ink-2)', lineHeight: 1.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 130 }}>{m.label}</span>
          </button>
        );
      })}
    </div>
  );
}

function ActiveMilestoneCard({ milestone, currentPage }: any) {
  if (!milestone) return null;
  const target = milestone.targetPage || 0;
  const remaining = Math.max(0, target - currentPage);
  const pct = target > 0 ? Math.min(100, Math.round((currentPage / target) * 100)) : 0;
  return (
    <div style={{ margin: '0 16px 14px', padding: '16px 18px', borderRadius: 18, background: 'linear-gradient(160deg, var(--ember-soft), var(--paper-2) 70%)', border: '1px solid color-mix(in oklab, var(--ember) 20%, var(--line))', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: -30, right: -20, opacity: 0.08 }}><IcoFlame size={120} style={{ color: 'var(--ember)' }} /></div>
      <div style={{ position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span className="mono" style={{ fontSize: 10.5, color: 'var(--ember-2)', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--ember)', animation: 'e2Pulse 2s infinite' }} />Marco {milestone.n} ativo
          </span>
          {milestone.deadline && <span className="mono" style={{ fontSize: 10.5, color: 'var(--ink-3)', display: 'flex', alignItems: 'center', gap: 4 }}><IcoClock size={12} />{milestone.deadline}</span>}
        </div>
        <h2 className="serif" style={{ margin: '0 0 12px', fontSize: 25, lineHeight: 1.22, color: 'var(--ink)' }}>{milestone.label}</h2>
        {target > 0 && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 7, fontSize: 12.5 }}>
              <span style={{ color: 'var(--ink-2)' }}>Você está na <strong style={{ color: 'var(--ink)', whiteSpace: 'nowrap' }}>p. {currentPage}</strong></span>
              <span style={{ color: remaining > 0 ? 'var(--ink-3)' : 'var(--sage)' }}>{remaining > 0 ? `faltam ${remaining} págs` : 'meta alcançada!'}</span>
            </div>
            <div style={{ height: 7, borderRadius: 999, background: 'var(--paper-3)', overflow: 'hidden' }}>
              <div style={{ height: '100%', width: pct + '%', borderRadius: 999, background: 'linear-gradient(90deg, var(--ember), var(--ember-2))', transition: 'width 0.6s' }} />
            </div>
          </>
        )}
        <div className="mono" style={{ fontSize: 10, color: 'var(--ink-4)', marginTop: 6 }}>{milestone.chapterRef ? milestone.chapterRef + ' · ' : ''}{milestone.totalPosts || 0} estudos no marco</div>
      </div>
    </div>
  );
}

function ClosedMilestoneBanner({ milestone, onClear }: any) {
  return (
    <div style={{ margin: '0 16px 14px', padding: '14px 16px', borderRadius: 16, background: 'var(--paper-2)', border: '1px solid var(--line)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span className="mono" style={{ fontSize: 10.5, color: 'var(--sage)', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'flex', alignItems: 'center', gap: 5 }}><IcoCheck size={13} />Marco {milestone.n}{milestone.closedOn ? ` · encerrado ${milestone.closedOn}` : ' · encerrado'}</span>
        <button onClick={onClear} style={{ fontSize: 12, color: 'var(--ink-3)', fontWeight: 600 }}>Voltar ao ativo</button>
      </div>
      <h2 className="serif" style={{ margin: '8px 0 0', fontSize: 22, color: 'var(--ink)', lineHeight: 1.1 }}>{milestone.label}</h2>
      <div className="mono" style={{ fontSize: 10.5, color: 'var(--ink-4)', marginTop: 4 }}>{milestone.chapterRef ? milestone.chapterRef + ' · ' : ''}{milestone.totalPosts || 0} estudos{milestone.closedBy ? ` · fechado por ${milestone.closedBy}` : ''}</div>
    </div>
  );
}

function FiosStrip({ themes, onOpenTheme }: any) {
  if (!themes?.length) return null;
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '0 16px 9px' }}>
        <IcoTheme size={15} style={{ color: 'var(--ember)' }} />
        <span className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Fios de estudo</span>
        <span style={{ fontSize: 11.5, color: 'var(--ink-4)' }}>· toque pra revisitar um assunto</span>
      </div>
      <div className="scroll-x" style={{ display: 'flex', gap: 9, padding: '0 16px' }}>
        {themes.map((th: any) => (
          <button key={th.tag} onClick={() => onOpenTheme(th.tag)} style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 6, padding: '13px 15px', borderRadius: 14, minWidth: 140, background: 'var(--paper-2)', border: '1px solid var(--line)', textAlign: 'left' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ width: 26, height: 26, borderRadius: 8, background: 'var(--ember-soft)', display: 'grid', placeItems: 'center' }}><IcoTheme size={14} style={{ color: 'var(--ember)' }} /></span>
              <span className="mono" style={{ fontSize: 11, color: 'var(--ink-3)' }}>{th.count}</span>
            </div>
            <span className="serif" style={{ fontSize: 18, color: 'var(--ink)', lineHeight: 1.05 }}>{th.tag}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

function FilterTabs({ filter, setFilter }: any) {
  return (
    <div className="scroll-x" style={{ display: 'flex', gap: 7, padding: '0 16px' }}>
      {STUDY_FILTERS.map((f: any) => {
        const on = filter === f.id;
        return (
          <button key={f.id} onClick={() => setFilter(f.id)} style={{ flexShrink: 0, padding: '7px 14px', borderRadius: 999, fontSize: 13, fontWeight: 600, background: on ? 'var(--ember)' : 'var(--paper-2)', color: on ? '#1a1208' : 'var(--ink-3)', border: `1px solid ${on ? 'var(--ember)' : 'var(--line)'}`, transition: 'all 0.18s' }}>{f.label}</button>
        );
      })}
    </div>
  );
}

function SearchBar({ value, onChange }: any) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9, background: 'var(--paper-2)', border: `1px solid ${value ? 'var(--line-strong)' : 'var(--line)'}`, borderRadius: 12, padding: '10px 12px' }}>
      <IcoSearch size={17} style={{ color: value ? 'var(--ember-2)' : 'var(--ink-3)', flexShrink: 0 }} />
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder="Buscar por frase, membro ou tipo…" style={{ flex: 1, minWidth: 0, background: 'none', border: 'none', outline: 'none', color: 'var(--ink)', fontSize: 14.5 }} />
      {value && <button onClick={() => onChange('')} style={{ color: 'var(--ink-4)', padding: 2, flexShrink: 0 }} aria-label="Limpar busca"><IcoClose size={16} /></button>}
    </div>
  );
}

function EmptyState() {
  return (
    <div style={{ display: 'grid', placeItems: 'center', textAlign: 'center', padding: '50px 30px', gap: 12 }}>
      <div style={{ width: 60, height: 60, borderRadius: 20, background: 'var(--paper-2)', display: 'grid', placeItems: 'center' }}><IcoFlame size={28} style={{ color: 'var(--ink-4)' }} /></div>
      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--ink-2)' }}>Nada aqui ainda</div>
      <div style={{ fontSize: 13.5, color: 'var(--ink-4)', lineHeight: 1.5, maxWidth: 240 }}>Seja o primeiro a escrever um estudo aqui. Toque em <strong style={{ color: 'var(--ink-2)' }}>Escrever</strong> e comece a conversa.</div>
    </div>
  );
}
function SearchEmpty({ query }: any) {
  return (
    <div style={{ display: 'grid', placeItems: 'center', textAlign: 'center', padding: '50px 30px', gap: 12 }}>
      <div style={{ width: 60, height: 60, borderRadius: 20, background: 'var(--paper-2)', display: 'grid', placeItems: 'center' }}><IcoSearch size={26} style={{ color: 'var(--ink-4)' }} /></div>
      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--ink-2)' }}>Nada encontrado</div>
      <div style={{ fontSize: 13.5, color: 'var(--ink-4)', lineHeight: 1.5, maxWidth: 250 }}>Nenhum estudo combina com “{query}”. Tente outra frase, o nome de um membro ou um tipo.</div>
    </div>
  );
}

export function EstudoFeed({
  posts, milestones, clubName, clubBook, filter, setFilter, selectedMilestone, setSelectedMilestone,
  currentPage, themes, visibleCount, onLoadMore, hasMore, onCompose, onOpenTheme, search, setSearch, canPost = true, onBack, headerExtra, loading, storiesTray,
}: any) {
  const active = milestones.find((m: any) => m.state === 'active');
  const selMs = milestones.find((m: any) => m.id === selectedMilestone);
  const searching = (search || '').trim().length > 0;

  return (
    <div style={{ minHeight: '100vh', paddingBottom: 96 }}>
      <header style={{ position: 'sticky', top: 0, zIndex: 20, background: 'color-mix(in oklab, var(--paper) 90%, transparent)', backdropFilter: 'blur(12px)', borderBottom: '1px solid var(--line)', paddingTop: 'var(--sat,0px)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px 11px' }}>
          <button onClick={onBack} style={{ width: 38, height: 38, borderRadius: 11, display: 'grid', placeItems: 'center', color: 'var(--ink-2)', background: 'var(--paper-2)', flexShrink: 0, border: '1px solid var(--line)' }}><IcoBack size={20} /></button>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: 16, color: 'var(--ink)', letterSpacing: '-0.01em', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{clubName || 'Estudo'}</div>
            {clubBook && <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 1 }}>
              <BookCover book={clubBook} w={11} h={15} />
              <span style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 12.5, color: 'var(--ink-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{clubBook.title}</span>
            </div>}
          </div>
          {headerExtra}
        </div>
        <div style={{ paddingBottom: 11, display: 'flex', flexDirection: 'column', gap: 11 }}>
          <div style={{ padding: '0 16px' }}><SearchBar value={search} onChange={setSearch} /></div>
          {!searching && <FilterTabs filter={filter} setFilter={setFilter} />}
        </div>
      </header>

      {storiesTray}

      <div style={{ paddingTop: 16 }}>
        {searching ? (
          <div style={{ padding: '0 16px 12px' }}>
            <span className="mono" style={{ fontSize: 11.5, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{posts.length} resultado{posts.length === 1 ? '' : 's'} para “{search.trim()}”</span>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 14 }}>
              <MilestoneRail milestones={milestones} selected={selectedMilestone} onSelect={setSelectedMilestone} />
            </div>
            {selMs && selMs.state === 'closed'
              ? <ClosedMilestoneBanner milestone={selMs} onClear={() => setSelectedMilestone(null)} />
              : <ActiveMilestoneCard milestone={active} currentPage={currentPage} />}
            {!selectedMilestone && filter === 'all' && <FiosStrip themes={themes} onOpenTheme={onOpenTheme} />}
          </>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14, padding: '0 16px' }}>
          {loading && posts.length === 0 && <div style={{ textAlign: 'center', padding: 40, color: 'var(--ink-4)' }}>Carregando…</div>}
          {!loading && posts.length === 0 && (searching ? <SearchEmpty query={search.trim()} /> : <EmptyState />)}
          {posts.map((p: any) => <PostCard key={p.id} post={p} />)}
        </div>

        {hasMore && (
          <div style={{ padding: '18px 16px 0', display: 'grid', placeItems: 'center' }}>
            <button onClick={onLoadMore} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '11px 22px', borderRadius: 999, background: 'var(--paper-2)', border: '1px solid var(--line-strong)', color: 'var(--ink-2)', fontSize: 14, fontWeight: 600 }}>
              <IcoChevDown size={16} />Carregar mais estudos
            </button>
          </div>
        )}
      </div>

      {canPost && <button onClick={() => onCompose()} style={{
        position: 'fixed', right: 'max(18px, calc(50% - 230px + 18px))', bottom: 'calc(22px + var(--sab,0px))', zIndex: 30,
        height: 56, paddingInline: 20, borderRadius: 999, background: 'var(--ember)', color: '#1a1208',
        display: 'flex', alignItems: 'center', gap: 9, boxShadow: 'var(--shadow-ember)', fontWeight: 700, fontSize: 15,
      }}>
        <IcoFlame size={20} fill="#1a1208" />Escrever
      </button>}
    </div>
  );
}
